import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

const Contact = () => {
    return (
        <section id="contact" className="section">
            <div className="section-header">
                <h2 className="section-title">
                    Get in <span className="highlight-yellow">Touch</span>
                </h2>
                <p className="section-subtitle">
                    Ready to transform your child's academic journey?
                </p>
            </div>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                style={{
                    maxWidth: '800px',
                    margin: '0 auto',
                    textAlign: 'center',
                    padding: '3rem 1.5rem'
                }}
            >
                <p style={{ fontSize: '1.2rem', lineHeight: '1.8', color: '#666', marginBottom: '2rem' }}>
                    We know how <strong>challenging</strong> it can be to find the right tutor in the Middle East.
                    That's exactly why we created Synapse Tutors—to connect your family with <strong>world-class British curriculum experts</strong>.
                </p>

                <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#666', marginBottom: '3rem' }}>
                    Learn more about our story and why quality education shouldn't be hard to access.
                </p>

                <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                    <Link
                        to="/about"
                        className="button-primary"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            textDecoration: 'none',
                            padding: '1rem 2rem',
                            fontSize: '1.1rem'
                        }}
                    >
                        Learn About Us <FaArrowRight />
                    </Link>

                    <a
                        href="mailto:info@synapsetutors.com"
                        className="button-outline"
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            padding: '1rem 2rem',
                            fontSize: '1.1rem',
                            border: '2px solid var(--color-primary)',
                            color: 'var(--color-primary)',
                            background: 'transparent',
                            borderRadius: '8px',
                            fontWeight: '600',
                            textDecoration: 'none',
                            transition: 'all 0.3s'
                        }}
                    >
                        Email Us Directly
                    </a>
                </div>

                <div style={{ marginTop: '3rem', padding: '2rem', background: '#f8f9fa', borderRadius: '12px' }}>
                    <p style={{ fontSize: '0.95rem', color: '#666', marginBottom: '0.5rem' }}>
                        📧 <strong>Email:</strong> info@synapsetutors.com
                    </p>
                    <p style={{ fontSize: '0.95rem', color: '#666', marginBottom: 0 }}>
                        💬 <strong>WhatsApp:</strong> +971 50 123 4567
                    </p>
                </div>
            </motion.div>
        </section>
    );
};

export default Contact;
